export default __webpack_public_path__ + "static/media/attachment_icon.f2e1b9d5.svg";